import React, { useEffect, useState } from "react"
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Nav,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap"
import {
  Field,
  reduxForm,
  FormSection,
  initialize,
  formValueSelector,
  change,
} from "redux-form"
import {
  AsyncTypeahedSelect,
  CheckboxField,
  RadioField,
} from "components/RenderInput"
import { FORM_NAMES } from "constants/index"
import { connect, useSelector } from "react-redux"
import {
  getCommentBoard,
  getMetaTags,
  getUsersBySearch,
  initChatSession,
  joinEvent,
  newMessage,
  resetCommentBoard,
  setSessionStatus,
  updateCommentBoardLayout,
} from "store/actions"
import { disconnect } from "services/quickblox"
import { LoadingIndicator } from "components/LoadingIndicator"
import { SaveButton } from "components/Buttons"
import ChatBox from "./chatBox"
import MenuFeatureHyperlinks from "../menuFeatureHyperlinks"

let CommentBoard = props => {
  const TABS = {
    CHAT: 1,
    SETUP: 2,
    HYPERLINKS: 3,
  }
  const [activeTab, setActiveTab] = useState(TABS.CHAT)

  const markAsActive = tab => {
    return activeTab === tab ? "active" : ""
  }

  const isUserPartOfTheEvent = () => {
    const isHost = props?.selectedEvent?.user_id === props.currentUser.id
    let isGuest = false

    props?.selectedEvent?.rsvps?.forEach(x => {
      if (x.user_id === props.currentUser.id) {
        isGuest = true
      }
    })
    return isHost || isGuest
  }

  const onMessageListener = (senderId, message) => {
    const mappedMessage = {
      _id: message.id,
      attachments: message.extension.attachments || [],
      date_sent: message.extension.date_sent,
      message: message.body,
      sender_id: senderId,
    }
    props.newMessage(mappedMessage)
  }

  useEffect(() => {
    if (props?.fromEvent) {
      if (isUserPartOfTheEvent()) {
        props.getCommentBoard({
          menu_item_id: props?.feature?.id,
          event_Id: props?.selectedEvent?.id,
        })
      } else {
        props.joinEvent({ eventId: props?.selectedEvent?.id })
        props.getCommentBoard({
          menu_item_id: props?.feature?.id,
          event_Id: props?.selectedEvent?.id,
        })
      }
    } else {
      props?.getCommentBoard({})
    }
    props?.getMetaTags({ hide_for_business_unit: 1 })
    return () => {
      props.resetCommentBoard()
      disconnect(() => props.setSessionStatus(false))
    }
  }, [])

  const getGuestIds = () => {
    let guestIds = []
    if (props?.selectedEvent?.rsvps) {
      props?.selectedEvent?.rsvps.forEach(x => guestIds.push(x?.user_id))
    }
    if (props?.selectedEvent?.hosts) {
      props?.selectedEvent?.hosts.forEach(x => guestIds.push(x?.id))
    }
    if (guestIds.indexOf(props.chatCredentials.qb_id) === -1) {
      guestIds.push(parseInt(props.chatCredentials.qb_id))
    }
    return guestIds
  }

  useEffect(() => {
    if (props.commentBoard) {
      props.initializeForm({
        comment_board_form: {
          template_id: props.commentBoard.template_id.toString(),
          notifications: props.commentBoard.notifications_disabled,
          mediaUploadAccessType: props?.commentBoard?.media_upload_access_type,
          socialProfileDisabled: !props?.commentBoard?.social_profile_disabled,
          tagSearch: props?.commentBoard?.media_upload_tags?.map(tag => ({
            ...tag,
            label: tag.tag,
            value: tag.id,
          })),
          userSearch: props?.commentBoard?.mediaUploadEnabledUsers?.map(
            user => ({
              ...user,
              label: `${user.first_name} ${user.last_name} (${user.email})`,
              value: user.id,
            })
          ),
          media_upload_setup_enabled:
            props?.commentBoard?.media_upload_access_type !== "nobody",
          postUsers: props?.commentBoard?.post_access_type,
          postUserSearch: props?.commentBoard?.post_users?.map(user => ({
            ...user,
            label: `${user.first_name} ${user.last_name} (${user.email})`,
            value: user.id,
          })),
          postTagSearch: props?.commentBoard?.post_tags?.map(tag => ({
            ...tag,
            label: tag.tag,
            value: tag.id,
          })),
        },
      })
    }
  }, [props.commentBoard])

  useEffect(() => {
    if (props.commentBoard && !props.sessionIsActive) {
      props.initChatSession({
        userId: props.chatCredentials.qb_id,
        login: props.chatCredentials.name,
        password: props.chatCredentials.password,
        dialogId: props.commentBoard.dialog_id,
        guestIds: props?.fromEvent ? getGuestIds() : null,
        onMessage: onMessageListener,
        vendor_id: props.vendorId,
        menu_item_id: props.commentBoard.menu_item_id,
      })
    }
  }, [props.commentBoard, props.sessionIsActive])

  const handleSave = () => {
    const mediaUploadEnabledUsers = props?.formValues?.userSearch?.map(
      user => user
    )
    const mediaUploadEnabledUsersIds = props?.formValues?.userSearch?.map(
      user => user?.id
    )
    const tags = props?.formValues?.tagSearch?.map(tag => tag)
    const tag_ids = props?.formValues?.tagSearch?.map(tag => tag?.id)
    props.updateCommentBoardLayout({
      ...props.commentBoard,
      template_id: props?.formValues?.template_id,
      notifications_disabled: props?.formValues?.notifications ? 1 : 0,
      social_profile_disabled: props?.formValues?.socialProfileDisabled ? 0 : 1,
      media_upload_access_type: props?.formValues?.mediaUploadAccessType,
      mediaUploadEnabledUsers:
        props?.formValues?.mediaUploadAccessType === "users"
          ? mediaUploadEnabledUsers
          : [],
      mediaUploadEnabledUsersIds:
        props?.formValues?.mediaUploadAccessType === "users"
          ? mediaUploadEnabledUsersIds
          : [],
      media_upload_tags:
        props?.formValues?.mediaUploadAccessType === "tags" ? tags : [],
      media_upload_tag_ids:
        props?.formValues?.mediaUploadAccessType === "tags" ? tag_ids : [],
      media_upload_setup_enabled:
        props?.formValues?.mediaUploadAccessType !== "nobody",
      ///
      post_access_type: props?.formValues?.postUsers,
      post_users:
        props?.formValues?.postUsers === "users"
          ? props?.formValues?.postUserSearch
          : [],
      post_tags:
        props?.formValues?.postUsers === "tags"
          ? props?.formValues?.postTagSearch
          : [],
      post_tag_ids:
        props?.formValues?.postUsers === "tags"
          ? props?.formValues?.postTagSearch?.map(tag => tag?.value)
          : [],
      // media_upload_setup_enabled:
      //   props?.formValues?.mediaUploadAccessType !== "nobody",
    })
  }

  return (
    <FormSection name={props.form}>
      <Card>
        <CardBody className="shadow-sm">
          {props?.fromEvent && !!props?.feature && (
            <Row>
              <Col xl={10}>
                <h3>{props.feature.label}</h3>
              </Col>
            </Row>
          )}
          <Nav pills tabs>
            <NavLink
              className={markAsActive(TABS.CHAT)}
              onClick={() => setActiveTab(TABS.CHAT)}
            >
              Chat
            </NavLink>
            <NavLink
              className={markAsActive(TABS.SETUP)}
              onClick={() => setActiveTab(TABS.SETUP)}
            >
              Setup
            </NavLink>
            {props?.isEventFeature &&
              (!!props?.vendorConfig?.nfc_hyperlinks ||
                !!props?.vendorConfig?.communication_hyperlinks) && (
                <NavLink
                  className={markAsActive(TABS.HYPERLINKS)}
                  onClick={() => setActiveTab(TABS.HYPERLINKS)}
                >
                  Hyperlinks
                </NavLink>
              )}
          </Nav>
          <TabContent activeTab={activeTab}>
            <TabPane tabId={TABS.CHAT} style={{ animation: "none" }}>
              {!props.QBChatLoaded ? (
                <LoadingIndicator />
              ) : (
                <ChatBox fromEvent={props?.fromEvent} />
              )}
            </TabPane>
            <TabPane tabId={TABS.SETUP} style={{ animation: "none" }}>
              {props?.fromEvent && (
                <React.Fragment>
                  <Row className="mt-3">
                    <Col xs={12}>
                      <h5>Select Layout:</h5>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12}>
                      <Field
                        name="template_id"
                        component={RadioField}
                        value="1"
                        label="Default Board"
                        type="radio"
                        // onChange={(event, newValue) => {
                        //   props.updateCommentBoardLayout({
                        //     ...props.commentBoard,
                        //     template_id: newValue,
                        //   })
                        // }}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12}>
                      <Field
                        name="template_id"
                        component={RadioField}
                        value="2"
                        label="Social Feed Style"
                        type="radio"
                        // onChange={(event, newValue) => {
                        //   props.updateCommentBoardLayout({
                        //     ...props.commentBoard,
                        //     template_id: newValue,
                        //   })
                        // }}
                      />
                    </Col>
                  </Row>
                </React.Fragment>
              )}
              <Row className="mt-1">
                <Col xs={12}>
                  <Field
                    name="notifications"
                    component={CheckboxField}
                    label={"Disable Notifications"}
                    // onChange={(event, newValue) => {
                    //   props.updateCommentBoardLayout({
                    //     ...props.commentBoard,
                    //     notifications_disabled: newValue ? 1 : 0,
                    //   })
                    // }}
                  />
                </Col>
              </Row>

              <Row>
                <Col xs={12}>
                  <Field
                    name="socialProfileDisabled"
                    component={CheckboxField}
                    label={"Allow users to view social profiles"}
                    // onChange={(event, newValue) => {
                    //   props.updateCommentBoardLayout({
                    //     ...props.commentBoard,
                    //     social_profile_disabled: newValue ? 0 : 1,
                    //   })
                    // }}
                  />
                </Col>
              </Row>

              <Row>
                <Col xs={12}>
                  <Field
                    name="media_upload_setup_enabled"
                    component={CheckboxField}
                    label={"Upload Media from Local Devices (Photos & Videos)"}
                    onChange={(event, newValue) => {
                      if (newValue) {
                        props?.change(
                          "comment_board_form.mediaUploadAccessType",
                          "all"
                        )
                      } else {
                        props?.change(
                          "comment_board_form.mediaUploadAccessType",
                          "nobody"
                        )
                      }
                    }}
                  />
                </Col>
              </Row>

              {props?.formValues?.media_upload_setup_enabled && (
                <Card className="mt-2">
                  <CardHeader>
                    <h5>WHO CAN UPLOAD MEDIA </h5>
                  </CardHeader>
                  <CardBody>
                    <Row className="ms-2">
                      <Col xs={12}>
                        <Field
                          name="mediaUploadAccessType"
                          component={RadioField}
                          value="all"
                          label="All Users"
                          type="radio"
                        />
                      </Col>
                    </Row>
                    <Row className="ms-2">
                      <Col xs={12}>
                        <Field
                          name="mediaUploadAccessType"
                          component={RadioField}
                          value="users"
                          label="Selected Users"
                          type="radio"
                        />
                      </Col>
                    </Row>
                    <Row className="ms-2">
                      <Col xs={12}>
                        <Field
                          name="mediaUploadAccessType"
                          component={RadioField}
                          value="tags"
                          label="Selected Tags"
                          type="radio"
                        />
                      </Col>
                    </Row>
                    {props?.formValues?.mediaUploadAccessType === "tags" && (
                      <Row className="mt-1 mb-3 ms-3">
                        <Col xl={6}>
                          <Field
                            name="tagSearch"
                            placeholder="Enter tag"
                            component={AsyncTypeahedSelect}
                            options={props?.metaTags.map(tag => ({
                              ...tag,
                              label: tag.tag,
                              value: tag.id,
                            }))}
                            isMulti={true}
                          />
                        </Col>
                      </Row>
                    )}
                    {props?.formValues?.mediaUploadAccessType === "users" && (
                      <Row className="mt-1 mb-3 ms-3">
                        <Col xl={6}>
                          <Field
                            name="userSearch"
                            component={AsyncTypeahedSelect}
                            placeholder="Search for specific users"
                            options={props?.usersBySearch.map(user => ({
                              ...user,
                              label: `${user.first_name} ${user.last_name} (${user.email})`,
                              value: user.id,
                            }))}
                            inlineValue={false}
                            onInputChange={text =>
                              props?.getUsersBySearch({
                                t: text,
                                include_admins: true,
                                ...(props?.fromEvent
                                  ? { event_id: props?.selectedEvent?.id }
                                  : {}),
                              })
                            }
                            isMulti={true}
                          />
                        </Col>
                      </Row>
                    )}
                  </CardBody>
                </Card>
              )}
              <Card className="mt-2">
                <CardHeader>
                  <h5>WHO CAN POST ON COMMENT BOARD</h5>
                </CardHeader>
                <CardBody>
                  <Row className="ms-2">
                    <Col xs={12}>
                      <Field
                        name="postUsers"
                        component={RadioField}
                        value="all"
                        label="All Users"
                        type="radio"
                      />
                    </Col>
                  </Row>
                  <Row className="ms-2">
                    <Col xs={12}>
                      <Field
                        name="postUsers"
                        component={RadioField}
                        value="users"
                        label="Selected Users"
                        type="radio"
                      />
                    </Col>
                  </Row>
                  <Row className="ms-2">
                    <Col xs={12}>
                      <Field
                        name="postUsers"
                        component={RadioField}
                        value="tags"
                        label="Selected Tags"
                        type="radio"
                      />
                    </Col>
                  </Row>
                  {props?.formValues?.postUsers === "tags" && (
                    <Row className="mt-1 mb-3 ms-3">
                      <Col xl={6}>
                        <Field
                          name="postTagSearch"
                          placeholder="Enter tag"
                          component={AsyncTypeahedSelect}
                          options={props?.metaTags.map(tag => ({
                            ...tag,
                            label: tag.tag,
                            value: tag.id,
                          }))}
                          isMulti={true}
                        />
                      </Col>
                    </Row>
                  )}
                  {props?.formValues?.postUsers === "users" && (
                    <Row className="mt-1 mb-3 ms-3">
                      <Col xl={6}>
                        <Field
                          name="postUserSearch"
                          component={AsyncTypeahedSelect}
                          placeholder="Search for specific users"
                          options={props?.usersBySearch.map(user => ({
                            ...user,
                            label: `${user.first_name} ${user.last_name} (${user.email})`,
                            value: user.id,
                          }))}
                          inlineValue={false}
                          onInputChange={text =>
                            props?.getUsersBySearch({
                              t: text,
                              include_admins: true,
                              ...(props?.fromEvent
                                ? { event_id: props?.selectedEvent?.id }
                                : {}),
                            })
                          }
                          isMulti={true}
                        />
                      </Col>
                    </Row>
                  )}
                </CardBody>
              </Card>
              <Row className="d-flex justify-content-center">
                <Col xs="auto">
                  <SaveButton
                    type="button"
                    content="Save"
                    size="sm"
                    onClick={handleSave}
                  />
                </Col>
              </Row>
              <Row
                style={{
                  margin: "1rem 0",
                  padding: "0 0.2rem",
                  overflow: "hidden",
                  borderTop: "1px solid Gainsboro",
                }}
              />
            </TabPane>
            {props?.isEventFeature &&
              (!!props?.vendorConfig?.nfc_hyperlinks ||
                !!props?.vendorConfig?.communication_hyperlinks) && (
                <TabPane tabId={TABS.HYPERLINKS} style={{ animation: "none" }}>
                  <MenuFeatureHyperlinks
                    event_id={props?.selectedEvent?.id}
                    menu_feature={props?.feature}
                  />
                </TabPane>
              )}
          </TabContent>
        </CardBody>
      </Card>
    </FormSection>
  )
}

CommentBoard = reduxForm({
  form: FORM_NAMES.COMMENT_BOARD,
  initialValues: {
    comment_board_form: {
      template_id: "2",
      postUsers: "all",
    },
  },
})(CommentBoard)

const selector = formValueSelector(FORM_NAMES.COMMENT_BOARD)

const mapStateToProps = state => ({
  vendorId: state.Login.vendorId,
  currentUser: state.Login.authUser,
  chatCredentials: state.Login.authUser.chat_credentials,
  selectedEvent: state.experiences.selectedEvent,
  commentBoard: state.CommentBoard.commentBoard,
  QBChatLoaded: state.CommentBoard.QBChatLoaded,
  sessionIsActive: state.CommentBoard.sessionIsActive,
  formValues: selector(state, FORM_NAMES.COMMENT_BOARD),
  usersBySearch: state.SiteUsers.usersBySearch,
  metaTags: state.Tags.metaTags,
  vendorConfig: state.clients.vendorConfig,
})

const mapDispatchToProps = dispatch => ({
  getCommentBoard: values => dispatch(getCommentBoard(values)),
  initializeForm: values =>
    dispatch(initialize(FORM_NAMES.COMMENT_BOARD, values)),
  resetCommentBoard: () => dispatch(resetCommentBoard()),
  updateCommentBoardLayout: values =>
    dispatch(updateCommentBoardLayout(values)),
  initChatSession: values => dispatch(initChatSession(values)),
  newMessage: values => dispatch(newMessage(values)),
  joinEvent: values => dispatch(joinEvent(values)),
  setSessionStatus: values => dispatch(setSessionStatus(values)),
  getUsersBySearch: values => dispatch(getUsersBySearch(values)),
  getMetaTags: values => dispatch(getMetaTags(values)),
  change: (field, value) =>
    dispatch(change(FORM_NAMES.COMMENT_BOARD, `${field}`, value)),
})

export default connect(mapStateToProps, mapDispatchToProps)(CommentBoard)
